document.querySelectorAll( '.b-blog-post-content-container' ).forEach( ( block ) => {

	const tableOfContent = block.querySelector( '.b-toc' );
	if ( tableOfContent ) {

		const nesting = parseInt( tableOfContent.dataset.nest, 10 );
		const contentWrapper = block.querySelector( '.content__inner' );
		if ( contentWrapper ) {

			let headers;
			switch ( nesting ) {

			case 1:
				headers = contentWrapper.querySelectorAll( 'h2, h3, h4' );
				break;
			case 2:
				headers = contentWrapper.querySelectorAll( 'h3, h4' );
				break;
			case 3:
				headers = contentWrapper.querySelectorAll( 'h3' );
				break;
			case 4:
				headers = contentWrapper.querySelectorAll( 'h2' );
				break;
			default:
				break;

			}

			let lastH3ListItem;
			const ol = document.createElement( 'ol' );
			tableOfContent.appendChild( ol );
			for ( let i = 0; i < headers.length; i++ ) {

				const header = headers[ i ];
				if ( !header.id ) {

					header.id = `header-${i}`;

				}
				const a = document.createElement( 'a' );
				a.href = `#${header.id}`;
				a.textContent = header.textContent;
				const listItem = document.createElement( 'li' );
				listItem.appendChild( a );
				let parentList = ol;
				if ( header.tagName === 'H3' ) {

					lastH3ListItem = listItem;
					ol.appendChild( listItem );
					if ( nesting === 2 || nesting === 1 ) {

						const ulNested = document.createElement( 'ul' );
						listItem.appendChild( ulNested );

					}

				} else if ( header.tagName === 'H2' ) {

					ol.appendChild( listItem );
					if ( nesting === 1 ) {

						const ulNested = document.createElement( 'ul' );
						listItem.appendChild( ulNested );

					}

				} else if ( header.tagName === 'H4' && ( nesting === 2 || nesting === 1 ) ) {

					if ( lastH3ListItem ) {

						parentList = lastH3ListItem.querySelector( 'ul' );
						parentList.appendChild( listItem );

					}

				}

			}

		}

	}

} );
